import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

import CoupleAvatar from '../CoupleAvatar';
import SaveButton from './SaveButton';

import { couplePronouns } from '../common';


const ProfileTab = (props) => {
    const {
        couple,
        setCouple,
        handleChange,
        state
    } = props;

    const provinces = window.provinces;

    const getAddressValue = name => {
        return state.couple_address_same ? state[`couple_${name}`] : (state[`groom_${name}`] || '');
    }

    const [formErrors, setFormErrors] = React.useState({});

    const pronouns = couplePronouns(couple);

    const genders = [
        { value: 'bride', label: 'Bride' },
        { value: 'groom', label: 'Groom' },
    ];

    return (
        <form>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid container justify="center" alignItems="center">
                        <CoupleAvatar couple={couple} setCouple={setCouple} />
                    </Grid>
                </Grid>
            </Grid>
            <Box>
                <Typography variant="overline" color="primary" display="block">
                   Contact information
                </Typography>
            </Box>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField
                        select
                        style={{ width: 150 }}
                        margin="normal"
                        onChange={handleChange('bride_title')}
                        label="Gender"
                        value={state.bride_title || ''}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {genders.map(option => (
                            <MenuItem key={`bride-gender-${option.value}`} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('bride_first_name')}
                        label={`${pronouns.bride} First Name`}
                        value={state.bride_first_name || ''}
                        required
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('bride_last_name')}
                        label={`${pronouns.bride} Last Name`}
                        value={state.bride_last_name || ''}
                        required
                    />
                    <TextField
                        error={formErrors.bride_email ? true : false}
                        fullWidth
                        margin="normal"
                        onChange={handleChange('bride_email')}
                        label={`${pronouns.bride} Email`}
                        value={state.bride_email || ''}
                        helperText={formErrors.bride_email}
                        required
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('couple_cell')}
                        label={`${pronouns.bride} Cell`}
                        value={state.couple_cell || ''}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        select
                        style={{ width: 150 }}
                        margin="normal"
                        onChange={handleChange('groom_title')}
                        label="Gender"
                        value={state.groom_title || ''}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {genders.map(option => (
                            <MenuItem key={`groom-gender-${option.value}`} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('groom_first_name')}
                        label={`${pronouns.groom} First Name`}
                        value={state.groom_first_name || ''}
                        required
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('groom_last_name')}
                        label={`${pronouns.groom} Last Name`}
                        value={state.groom_last_name || ''}
                        required
                    />
                    <TextField
                        error={formErrors.groom_email ? true : false}
                        fullWidth
                        margin="normal"
                        onChange={handleChange('groom_email')}
                        label={`${pronouns.groom} Email`}
                        value={state.groom_email || ''}
                        helperText={formErrors.groom_email}
                        required
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('groom_cell')}
                        label={`${pronouns.groom} Cell`}
                        value={state.groom_cell || ''}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('wedding_planner_email')}
                        label="Wedding Planner Email"
                        value={state.wedding_planner_email || ''}
                    />
                </Grid>
            </Grid>
            <Box mt={3}>
                <Typography variant="overline" color="primary" display="block">
                    Addresses
                </Typography>
            </Box>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <Box style={{height: 21, marginTop: 10}}>&nbsp;</Box>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('couple_address')}
                        label={`${pronouns.bride} Address`}
                        value={state.couple_address || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('couple_city')}
                        label="City"
                        value={state.couple_city || ''}
                    />
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        onChange={handleChange('couple_province_id')}
                        label="Province"
                        value={state.couple_province_id || ''}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {provinces.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.province_name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('couple_postal')}
                        label="Postal Code"
                        value={state.couple_postal || ''}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Box style={{marginBottom:-20}}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox color="primary" id="couple-address-same" checked={state.couple_address_same} onChange={handleChange('couple_address_same')} />
                                }
                                label={`Use same address as ${pronouns.bride.toLowerCase()}`}
                            />
                        </FormGroup>
                    </Box>
                    <TextField
                        fullWidth
                        disabled={state.couple_address_same}
                        margin="normal"
                        onChange={handleChange('groom_address')}
                        label={`${pronouns.groom} Address`}
                        value={getAddressValue('address')}
                    />
                    <TextField
                        fullWidth
                        disabled={state.couple_address_same}
                        margin="normal"
                        onChange={handleChange('groom_city')}
                        label="City"
                        value={getAddressValue('city')}
                    />
                    <TextField
                        select
                        fullWidth
                        disabled={state.couple_address_same}
                        margin="normal"
                        onChange={handleChange('groom_province_id')}
                        label="Province"
                        value={getAddressValue('province_id')}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {provinces.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.province_name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        disabled={state.couple_address_same}
                        margin="normal"
                        onChange={handleChange('groom_postal')}
                        label="Postal Code"
                        value={getAddressValue('postal')}
                    />
                </Grid>
            </Grid>

            <Box mt={3}>
                <Typography variant="overline" color="primary" display="block">
                    Notes
                </Typography>
            </Box>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('notes')}
                        multiline
                        value={state.notes || ''}
                    />
                </Grid>
            </Grid>

            <Box mt={3}>
                <Typography variant="overline" color="primary" display="block">
                    Inquiry Message
                </Typography>
            </Box>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        margin="normal"
                        multiline
                        defaultValue={couple.couple_message || ''}
                        InputProps={{
                            readOnly: true,
                          }}
                    />
                </Grid>
            </Grid>

            <Box mt={4} mb={3}>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={4}>
                        <SaveButton
                            state={state}
                            coupleId={couple.id}
                            setCouple={setCouple}
                            setFormErrors={setFormErrors}
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>
    )
};

export default ProfileTab;
